<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card color="primary" icon="mdi-harddisk" inline class="ml-0 px-5 py-4" title="Tabelas x Disco">
          <v-row>
            <v-col cols="6">
              <v-card tile>
                <v-subheader>Uso de Disco do Servidor Web</v-subheader>
                <v-divider />
                <v-card-text>
                  <uso-hd-servidor :fetchData="fetchDiskStatusWeb" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card tile>
                <v-subheader>Uso de Disco do Servidor SQL Server GeoPerdas</v-subheader>
                <v-divider />
                <v-card-text>
                  <div>
                    <template v-if="servidoresSqlServer.length > 0">
                      <uso-hd-servidor
                        v-for="servidor in servidoresSqlServer"
                        :key="servidor.nome"
                        :fetchData="() => fetchDiskStatusSqlServer(servidor)"
                      />
                    </template>
                    <v-alert v-else type="info" text>Nenhum servidor SQL Server GeoPerdas ativo encontrado.</v-alert>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-card tile>
                <v-subheader>Uso de Disco do Banco de Dados por tabela</v-subheader>
                <v-divider />
                <v-card-text>
                  <uso-hd-banco-dados-por-tabela />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card tile>
                <v-subheader>Uso de Disco da Aplicação Backend por diretório</v-subheader>
                <v-divider />
                <v-card-text>
                  <uso-hd-aplicacao-backend />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ServerConfigService from '@/services/ServerConfigService';
  import UsoHdBancoDadosPorTabela from '@/components/general/data-tables/UsoHdBancoDadosPorTabela';
  import UsoHdAplicacaoBackend from '@/components/general/data-tables/UsoHdAplicacaoBackend';
  import UsoHdServidor from '../../../components/general/graficos/UsoHdServidor.vue';

  export default {
    name: 'TabelasXDisco',
    components: {
      UsoHdBancoDadosPorTabela,
      UsoHdAplicacaoBackend,
      UsoHdServidor
    },
    data() {
      return {
        servidoresSqlServer: []
      };
    },
    mounted() {
      ServerConfigService.getSqlServerDiskStatus()
        .then(({ data }) => {
          this.servidoresSqlServer = Array.isArray(data) ? data : [];
        })
        .catch((error) => console.log('Error: ' + error));
    },
    methods: {
      fetchDiskStatusWeb() {
        return ServerConfigService.getServerDiskStatus();
      },
      fetchDiskStatusSqlServer(servidor) {
        return Promise.resolve({ data: servidor });
      }
    }
  };
</script>
